import Vue from 'vue'
import VueRouter from 'vue-router'
import TreeNodeManagement from '@/components/TreeNodeManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: TreeNodeManagement
  },
  {
    path: '/s/:shareCode',
    name: 'share',
    component: TreeNodeManagement,
    props: true
  },
  {
    // 兼容旧的 URL 格式
    path: '/dataset/:databaseId',
    redirect: to => ({ name: 'home' })
  },
  {
    // 捕获所有未匹配的路由，重定向到首页
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式，兼容静态托管
  base: process.env.BASE_URL,
  routes
})

export default router

